//View Event Details Component //Create Event Component
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import CommunityAbout from "../Posts/layouts/CommunityAbout";
import CommunityTopBar from "../Posts/layouts/CommunityTopBar";
import UpcomingEvents from "../Profile/UpcomingEvents";
import EventTopBar from "./EventTopBar";
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import eye2 from "../../assets/img/profile/eyesingle.svg"
import calendar from "../../assets/img/event/calendar.svg"
import evtype from "../../assets/img/event/type.svg"
import locationicon from "../../assets/img/event/map-pin.svg"
import capasity from "../../assets/img/event/users.svg"
import event from "../../assets/img/profile/event-img.png"
import pimg from "../../assets/img/profile/profile-img.svg"
import copy from "../../assets/img/profile/copy.svg"
import EventAbout from "../Posts/layouts/EventAbout";
import ViewEventTopBar from "./ViewEventTopBar";
import { getEventDetails } from "../../services/apiEvent";
import { API } from "../../services/api";
import moment from "moment";


const ViewEventDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [eventDetailArr, setEventDetailArr] = useState([]);
  const [eventAttendeeArr, setEventAttendeeArr] = useState([]);
  const [attendStatus, setAttendStatus] = useState("");
  const [copied, setCopied] = useState(false);
  const [copiedWeb, setCopiedWeb] = useState(false);
  useEffect(() => {
    fetchEventDetails();
  }, []);
  const fetchEventDetails = async () => {
    const formData = {
      userid: userData._id,
      eventid: data.eventId
    }
    let eventDetail = await getEventDetails(formData);
    setAttendStatus(eventDetail.isEventAttending)
    setEventDetailArr(eventDetail.event)
    setEventAttendeeArr(eventDetail.allAttendees)
  };
  const handleCopy = (link, type) => {
    navigator.clipboard.writeText(link).then(() => {
      if (type === "virtual") {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
      if (type === "web") {
        setCopiedWeb(true);
        setTimeout(() => setCopiedWeb(false), 2000);
      }
    });
  };
  const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

  const handleImageClick = (first, last, id, type) => {
    if (type === "individual") {
       const userName = `${slugify(first)}-${slugify(last)}`;
      if (userData._id === id)
        navigate('/profile');
      else
        navigate(`/profile/${userName}`, { state: { userId: id } })
    } else {
      if (userData._id === id)
        navigate('/organization');
      else
        navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
    }

  };
  const formatURL = (url) => {
  if (!url) return "";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};
  return (

    <div >
      <ViewEventTopBar banner={eventDetailArr.eventImage} details={eventDetailArr} attendStatus={attendStatus} fetchEventDetails={fetchEventDetails} />
      <div className="community-features main ml-0 mb-4">
        <div className="contents ml-0">
          <div className="events-list">
            <div className="event-itm d-flex">

              <div className="event-details w-100">
                <h2>{eventDetailArr.eventTitle}</h2>
                <div className="row  mt-3">
                  <div className="col-lg-6">
                    <ul className="event_specs" >
                      <li>
                        <div className="event-features-dh">
                          <img src={calendar} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >Start Date</lable>
                          <div className="event-time">
                            <p>
                             
                              {eventDetailArr.eventStartDate && eventDetailArr.eventStartDate ? (
                                `${moment(`${eventDetailArr.eventStartDate.split("T")[0]} ${eventDetailArr.eventStartTime}`, "YYYY-MM-DD hh:mm A")
                                  .format("MM/DD/YYYY, dddd [at] hh:mm A")} `
                              ) : ''}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="event-features-dh">
                          <img src={calendar} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >End Date</lable>
                          <div className="event-time">
                            <p>
                             
                              {eventDetailArr.eventEndDate && eventDetailArr.eventEndDate ? (
                                `${moment(`${eventDetailArr.eventEndDate.split("T")[0]} ${eventDetailArr.eventEndTime}`, "YYYY-MM-DD hh:mm A")
                                  .format("MM/DD/YYYY, dddd [at] hh:mm A")} `
                              ) : ''}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="event-features-dh">
                          <img src={capasity} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >Time zone</lable>
                          <div className="event-time">
                            <p>{eventDetailArr.timezone}</p>
                          </div>
                        </div>
                      </li>

                      {eventDetailArr.location && <li>
                        <div className="eventpeoples d-flex align-items-center" >
                          <div className="people-list">
                            
                            {eventAttendeeArr?.slice(0, 4).map((atten, index) => {
                              const user = atten?.userId;
                              const hasImage = user?.profileImage?.url;
                              const isPrivate = user?.profileSettings?.isPrivateProfile;
                              const imgSrc = hasImage && !isPrivate
                                ? API.uploadFilePath + user.profileImage.url
                                : profileimg;

                              return (
                                <img
                                  key={index}
                                  src={imgSrc}
                                  alt="attendee"
                                  className="community_thumb"
                                  onError={(e) => { e.target.onerror = null; e.target.src = profileimg }}
                                
                                />
                              );
                            })}
                          </div>
                          {eventAttendeeArr.length > 4 && <h6>{`${data.attenNo}+ Attending`}</h6>}
                        </div>
                      </li>}


                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul className="event_specs" >
                      <li>
                        <div className="event-features-dh">
                          <img src={capasity} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >Capacity</lable>
                          <div className="event-time">
                            <p>{eventDetailArr.eventCapacity}</p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="event-features-dh">
                          <img src={evtype} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >Event type</lable>
                          <div className="event-time">
                            <p>{eventDetailArr?.isVirtual === "yes" ? "Virtual" : eventDetailArr?.isVirtual === "no" ? "In Person" : "Hybrid"}</p>
                          </div>
                        </div>
                      </li>
                      {eventDetailArr.location ? <li>
                        <div className="event-features-dh">
                          <img src={locationicon} alt="test" className="event-f-icon" />
                          <lable className="event-f-name" >Location</lable>
                          <div className="event-time">
                            <p>{eventDetailArr.location}</p>
                          </div>
                        </div>
                      </li> :
                        <li>
                          <div className="eventpeoples d-flex align-items-center" >
                            <div className="people-list">
                              
                              {eventAttendeeArr?.slice(0, 4).map((atten, index) => {
                                const user = atten?.userId;
                                const hasImage = user?.profileImage?.url;
                                const isPrivate = user?.profileSettings?.isPrivateProfile;
                                const imgSrc = hasImage && !isPrivate
                                  ? API.uploadFilePath + user.profileImage.url
                                  : profileimg;

                                return (
                                  <img
                                    key={index}
                                    src={imgSrc}
                                    alt="attendee"
                                    className="community_thumb"
                                    onError={(e) => { e.target.onerror = null; e.target.src = profileimg }}
                                  
                                  />
                                );
                              })}
                            </div>
                            {eventAttendeeArr.length > 4 && <h6>{`${data.attenNo}+ Attending`}</h6>}
                          </div>
                        </li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="event-itm event-details pb-0">
              <h5 className="event-sub-heading" >Overview</h5>
              <p className="rightbar-descr" >{eventDetailArr.eventOverview}</p>

            </div>
            {eventDetailArr.virtualLink && <div className="event-itm event-details">
              <h5 className="event-sub-heading" >Virtual Link</h5>
              <div className="link-container">
                <span className="link-copy-name" >

                  <a
                    href={formatURL(eventDetailArr.virtualLink)}
                    className="link-copy-name"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {eventDetailArr.virtualLink}
                  </a></span>
                {copied && <div className="copied">Copied</div>}
                <button onClick={() => handleCopy(eventDetailArr.virtualLink, "virtual")}><img src={copy} alt="test" className="copy-icon" /> </button>
              </div>
            </div>}

            {eventDetailArr.websiteUrl && <div className="event-itm event-details">
              <h5 className="event-sub-heading" >Web Link</h5>
              <div className="link-container">
                <span className="link-copy-name" >
                  <a
                      href={formatURL(eventDetailArr.websiteUrl)}
                    className="link-copy-name"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {eventDetailArr.websiteUrl}
                  </a></span>
                {copiedWeb && <div className="copied">Copied</div>}
                <button onClick={() => handleCopy(eventDetailArr.websiteUrl, "web")}><img src={copy} alt="test" className="copy-icon" /> </button>
              </div>
            </div>}

          </div>
        </div>
        <EventAbout community={eventDetailArr.communityIds} details={eventDetailArr} />
      </div>
    </div>

  );

};
export default ViewEventDetails;